import { render, staticRenderFns } from "./icon-text.vue?vue&type=template&id=4144bad1&scoped=true"
import script from "./icon-text.vue?vue&type=script&setup=true&lang=ts"
export * from "./icon-text.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./icon-text.vue?vue&type=style&index=0&id=4144bad1&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4144bad1",
  null
  
)

export default component.exports